/**
 * Map Supabase auth error messages → i18n keys under `auth.errors.*`.
 * Supabase returns English strings; we map them to stable keys so the UI
 * can render the Georgian translation. Unknown errors fall back to
 * `auth.errors.unknown`.
 */
export function supabaseAuthErrorKey(error: { message?: string; code?: string } | null | undefined): string {
  if (!error) return 'auth.errors.unknown';
  const msg = (error.message ?? '').toLowerCase();
  const code = error.code ?? '';

  if (code === 'invalid_credentials' || msg.includes('invalid login credentials') || msg.includes('invalid password')) {
    return 'auth.errors.invalid_credentials';
  }
  if (code === 'user_already_exists' || msg.includes('already registered') || msg.includes('user already registered')) {
    return 'auth.errors.user_exists';
  }
  if (code === 'weak_password' || msg.includes('password should be at least')) {
    return 'auth.errors.password_too_short';
  }
  if (code === 'network_error' || msg.includes('network') || msg.includes('failed to fetch')) {
    return 'auth.errors.network';
  }
  return 'auth.errors.unknown';
}
